export function timeSeriesTicks (label) {
  if (label && label.length > 0) {
    const interval = Math.abs(label[label.length-1] - label[0]) / (1000*60*60)
    const options = [
      {name:'hour', max: 48, scale:1}, 
      {name:'day', max: 24*7, scale:24}, 
      {name: 'week', max:24*7*6, scale:24*7},
      {name: 'month', max:Number.MAX_VALUE, scale:24*30 }]
    const unitIndex = options.findIndex (opt => opt.max >= interval)
    const step = Math.max((interval / options[unitIndex].scale) / 5, 1)
    return {time: {unit: options[unitIndex].name, stepSize: step, }}
  } 
  return {time: {unit: 'hour', stepSize: 1, }}
}
export function timeLineTicks (label) {
  if (label && label.length > 0) {
    const interval = Math.abs(label[label.length-1] - label[0]) / (1000*60*60)
    const options = [
      {name:'hour', max: 48}, 
      {name:'day', max: 24*14}, 
      {name: 'week', max:24*56},
      {name: 'month', max:Number.MAX_VALUE}]
    const unitIndex = options.findIndex (opt => opt.max >= interval)
    return {time: {unit: options[unitIndex].name, stepSize: 1, }}
  } 
  return {time: {unit: 'hour', stepSize: 1, }}
}
